module.exports = __webpack_public_path__ + "img/icon01.b2214ab6.png";